// Table of contents:
// 1 Table
// 2 Delete assignee
// 3 Create assignee
// 4 Edit assignee
import { RoleAssignments } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createRoleAssignments = (): RoleAssignments => {
  return {
    // 1 Table
    table: {
      enabled: true,
      title: getTranslationsForConfig('roleAssignments.table.title'), // t('roleAssignments.table.title')
      columns: [
        {
          // project
          dataType: 'project',
          field: 'projectName',
          filter: true,
          filterPlaceholder: getTranslationsForConfig(
            'roleAssignments.table.columns.project.filterPlaceholder',
          ), // t('roleAssignments.table.columns.project.filterPlaceholder')
          header: getTranslationsForConfig(
            'roleAssignments.table.columns.project.header',
          ), // t('roleAssignments.table.columns.project.header')
          sortable: true,
        },
        {
          // Status
          dataType: 'active',
          field: 'status',
          filter: true,
          header: getTranslationsForConfig(
            'suppliers.table.columns.status.header',
          ), // t('suppliers.table.columns.status.header')
          sortable: true,
        },
        {
          // assignee
          dataType: 'string',
          field: 'assignee',
          filter: true,
          filterPlaceholder: getTranslationsForConfig(
            'roleAssignments.table.columns.assignee.filterPlaceholder',
          ), // t('roleAssignments.table.columns.assignee.filterPlaceholder')
          header: getTranslationsForConfig(
            'roleAssignments.table.columns.assignee.header',
          ), // t('roleAssignments.table.columns.assignee.header')
          sortable: true,
        },
        {
          // role
          dataType: 'role',
          field: 'role',
          filter: true,
          header: getTranslationsForConfig(
            'roleAssignments.table.columns.role.header',
          ), // t('roleAssignments.table.columns.role.header')
          sortable: true,
        },
      ],
      emptyMessageDetails: getTranslationsForConfig(
        'roleAssignments.table.emptyMessageDetails',
      ), // t('roleAssignments.table.emptyMessageDetails')
      emptyMessageTitle: getTranslationsForConfig(
        'roleAssignments.table.emptyMessageTitle',
      ), // t('roleAssignments.table.emptyMessageTitle')
      paginator: true,
      rows: 20,
      rowsPerPageOptions: [20, 50, 100],
      sortField: 'projectName',
      sortOrder: 1,
      scrollHeight: '70vh',
    },
    // 2 Delete assignee
    deleteAssignee: {
      enabled: true,
    },
    // 3 Create assignee
    createAssignee: {
      enabled: true,
      // Assignee
      assignee: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.assignee.label',
        ), // t('roleAssignments.table.edit.dialog.form.assignee.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.assignee.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.assignee.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Role
      role: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.role.label',
        ), // t('roleAssignments.table.edit.dialog.form.role.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.role.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.role.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Project
      project: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.project.label',
        ), // t('roleAssignments.table.edit.dialog.form.project.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.project.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.project.placeholder')
        readonly: false,
        validation: {
          isRequired: false,
        },
      },
    },
    // 4 Edit assignee
    editAssignee: {
      enabled: true,
      // Assignee
      assignee: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.assignee.label',
        ), // t('roleAssignments.table.edit.dialog.form.assignee.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.assignee.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.assignee.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Role
      role: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.role.label',
        ), // t('roleAssignments.table.edit.dialog.form.role.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.role.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.role.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
      // Project
      project: {
        enabled: true,
        label: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.project.label',
        ), // t('roleAssignments.table.edit.dialog.form.project.label')
        placeholder: getTranslationsForConfig(
          'roleAssignments.table.edit.dialog.form.project.placeholder',
        ), // t('roleAssignments.table.edit.dialog.form.project.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
        },
      },
    },
  }
}
